export enum NgxPopperjsTriggers {
  click = "click",
  hover = "hover",
  mousedown = "mousedown",
  none = "none"
}
